// const { useState, useEffect, useMemo } = React,
//   { BrowserRouter, useHistory } = ReactRouterDOM;
import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router";
import "./mainfeature.css";

//conditional wrapper component
const ConditionalWrapper = ({ initialWrapper, condition, wrapper, children }) =>
  condition ? wrapper(children) : initialWrapper(children);

const MainFeatureTab = ({
  activeTab,
  tabsList,
  isFancyTabs = true,
  isVertical,
  isRightToLeftLanguage,
}) => {
  const history = useHistory(),
    [isUrlTabs, setIsUrlTabs] = useState(false),
    [currentActiveTab, setCurrentActiveTab] = useState(),
    [previousActiveTab, setPreviousActiveTab] = useState(0),
    animationClassName = useMemo(() => {
      if (currentActiveTab !== undefined) {
        if (isVertical) {
          if (currentActiveTab < previousActiveTab) {
            return "bottom-to-top-animation";
          } else {
            return "top-to-bottom-animation";
          }
        } else {
          if (isRightToLeftLanguage) {
            if (currentActiveTab < previousActiveTab) {
              return "left-to-right-animation";
            } else {
              return "right-to-left-animation";
            }
          } else {
            if (currentActiveTab < previousActiveTab) {
              return "right-to-left-animation";
            } else {
              return "left-to-right-animation";
            }
          }
        }
      }
    }, [
      isVertical,
      isRightToLeftLanguage,
      currentActiveTab,
      previousActiveTab,
    ]);

  useEffect(() => {
    if (tabsList.find((el) => el.tabUrl)) {
      setIsUrlTabs(true);
    } else {
      if (activeTab !== 0 && activeTab && activeTab < tabsList.length) {
        setCurrentActiveTab(activeTab);
      } else {
        setCurrentActiveTab(0);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isUrlTabs) {
      const currentActiveTabUrlIndex = tabsList.findIndex(
        (el) => el.tabUrl === history.location.pathname
      );
      setCurrentActiveTab(
        currentActiveTabUrlIndex !== -1 ? currentActiveTabUrlIndex : 0
      );
      setPreviousActiveTab(currentActiveTab ?? 0);
    }
    // eslint-disable-next-line
  }, [history.location.pathname, isUrlTabs]);

  const onChangeTab = (index, tabUrl) => {
    if (tabUrl) history.push(tabUrl);
    else {
      setPreviousActiveTab(currentActiveTab ?? 0);
      setCurrentActiveTab(index);
    }
  };

  return (
    <div className={`tabs ${isVertical ? "vertical-tabs" : ""}`}>
      <div
        className={`${isFancyTabs ? "fancy-labels-wrapper" : "labels-wrapper"}`}
      >
        <ConditionalWrapper
          initialWrapper={(children) => <>{children}</>}
          wrapper={(children) => <div className="labels">{children}</div>}
          condition={isFancyTabs}
        >
          {tabsList.map((el, i) => (
            <div
              className={`tab-label ${
                currentActiveTab === i ? " active-tab-label" : ""
              }`}
              key={i}
              onClick={() => {
                onChangeTab(i, el.tabUrl);
              }}
            >
              {el.label}
            </div>
          ))}
        </ConditionalWrapper>
      </div>
      <div
        className="tabs-content-wrapper"
        style={{ borderRadius: isFancyTabs ? 10 : 0 }}
      >
        {tabsList.map((el, i) => (
          <div
            className={`tab-content ${
              currentActiveTab === i ? " active-tab-content" : ""
            } ${animationClassName}`}
            key={i}
          >
            {currentActiveTab === i && el.content}
          </div>
        ))}
      </div>
    </div>
  );
};
export default MainFeatureTab;
